module.exports = __webpack_public_path__ + "src/img/cookies/iphones-3.afdf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cookies/iphones-3.png
// module id = 251
// module chunks = 0